import React from 'react';

import { Tooltip } from 'antd';

const ErrorTooltip = (props) => <Tooltip visible={!!props.errors} title={props.errors ? props.errors[0] : ''} />;

export default ErrorTooltip;
